import React from "react";

import "./IconWrapper.scss";

export type TIconWrapperVariant = "default" | "green" | "yellow" | "blue" | "light-blue" | "red" | "purple" | "violet";

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
    children?: React.ReactNode;
    variant?: TIconWrapperVariant;
    varient?: TIconWrapperVariant; // legacy misspelling support
}

export default function IconWrapper({ children, variant, varient, className, ...props }: IProps) {
    const resolvedVariant = variant || varient || "default";
    const classNames = ["userful-icon-wrapper", `${resolvedVariant}-icon-wrapper`, className].filter(Boolean).join(" ");

    return (
        <div className={classNames} {...props}>
            {children}
        </div>
    );
}
